import React from "react";
import PropTypes from "prop-types";
import GModal from "../../design/components/GModal";
import Button from "../../design/Button";
import '../../../newIndex.css';
const DeleteAppModal = ({ visible, closeModal, onDelete, appName, external }) => (
  <GModal
    visible={visible}
    heading={external ? "Uninstall app" : "Delete app"}
    closeModal={closeModal}
    noScrollbar={true}
    bottomButtons={[
      <Button
        key="cancel"
        buttonText="Cancel"
        variant="outlined"
        hierarchy="white"
        onClick={closeModal}
      />,
      <Button
        key="delete"
        buttonText={external ? "Uninstall" : "Delete"}
        variant="contained"
        hierarchy="red"
        onClick={onDelete}
        styleOverride={{ marginLeft: "8px" }}
      />
    ]}
    body={
      <div className="t7 color-4a text-center">
        Are you sure you want to {external ? "uninstall" : "permanently delete"} <strong>{appName}</strong> app?
      </div>
    }
    headingStyle={{
      fontWeight: "600",
      fontSize: "16px"
    }}
    bottomButtonsStyle={{
      display: "flex",
      justifyContent: "flex-end",
      padding: "0 16px 24px 16px",
      borderTop: 'none'
    }}
    modalStyle={{
      width: '443px',
      minWidth: '443px',
      minHeight: 'unset' 
    }}
  />
);

DeleteAppModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  appName: PropTypes.string.isRequired
};

export default DeleteAppModal;
